import styled from 'styled-components'
import { Button } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import FinishedOnboardingSVG from '../../assets/finished-onboarding.svg?react'
import { useOnboarding } from '../../contexts/OnboardingContext'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > span {
    margin-top: 24px;
  }
`

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`

const OnboardingComplete = ({ onPrevious, onNext }) => {
  const { selectedCaffeineOptions } = useOnboarding()
  const { t } = useTranslation('common')

  return (
    <Container>
      <ContentContainer>
        <FinishedOnboardingSVG />
        <span style={{ fontSize: 24, fontWeight: 700, textAlign: 'center' }}>
          {t('onboarding.complete.header')}
        </span>
        <span style={{ fontSize: 18, textAlign: 'center' }}>
          {t('onboarding.complete.description')}
        </span>
      </ContentContainer>
      <Footer>
        <Button
          variant='text'
          onClick={
            selectedCaffeineOptions[0]?.isNoCaffeine
              ? () => {
                onPrevious()
                onPrevious()
              }
              : onPrevious
          }
          startIcon={<ArrowBackIcon />}
        >
          {t('onboarding.complete.correct')}
        </Button>
        <Button
          variant='contained'
          onClick={onNext}
        >
          {t('onboarding.conclude')}
        </Button>
      </Footer>
    </Container>
  )
}

export default OnboardingComplete
